import { useEffect, useState } from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import Hero from '@/pages/home/components/Hero';
import Featured from '@/pages/home/components/Featured';
import Genres from '@/pages/home/components/Genres';
import TopList from '@/pages/home/components/TopList';
import Testimonials from '@/pages/home/components/Testimonials';
import Faq from '@/pages/home/components/Faq';
import About from '@/pages/home/components/About';

export default function Home() {
  const [query, setQuery] = useState('');
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleSearch = () => {
    const el = document.getElementById('featured');
    el?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <Navbar />
      <main>
        <Hero query={query} onQueryChange={setQuery} onSearch={handleSearch} />
        <Featured query={query} />
        <Genres />
        <TopList />
        <Testimonials />
        <Faq />
        <About />
      </main>
      <Footer />

      <button
        type="button"
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        aria-label="返回顶部"
        className={`fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-card transition-all hover:bg-primary-600 ${
          showTop ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-4 opacity-0'
        }`}
      >
        <i className="ri-arrow-up-line text-lg" aria-hidden="true"></i>
      </button>
    </>
  );
}